<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card card-padding-top">
                <app-empty-content [isVisible]="data.length === 0"
                    title="Nenhuma assinatura encontrada"
                    description="Não foi encontrada nenhuma assinatura nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <ng-container *ngIf="data.length > 0">
                    <ng-container *ngFor="let item of data">
                        <ng-container
                            *ngIf="item.signs && item.signs.length > 0">
                            <div class="col-12 d-flex justify-content-end mb-3">
                                <app-button [center]="true" [outline]="true"
                                    (onClick)="openDocumentInNewTab(item.file)">
                                    Visualizar documento
                                </app-button>
                            </div>

                            <div class="table-scroll-container">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Vínculo</th>
                                            <th>Data</th>
                                            <th class="text-center">Assinado
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let sign of item.signs">
                                            <td>
                                                <div
                                                    class="d-flex align-items-center">
                                                    <span
                                                        class="app-table-details-body-row-initials">
                                                        {{
                                                        getInitialsFromSign(sign)
                                                        }}
                                                    </span>
                                                    <div
                                                        class="dash-card-item-content">
                                                        <div
                                                            class="dash-card-item-content-title">
                                                            {{ getName(sign) }}
                                                        </div>
                                                        <div
                                                            class="dash-card-item-content-subtitle">
                                                            {{ sign.type_display
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{{ sign.type_display }}</td>
                                            <td>{{ formatDate(sign.updated_at)
                                                }}</td>
                                            <td class="text-center">
                                                <svg-icon
                                                    [src]="getSignedIcon(sign)"
                                                    class="status-icon"></svg-icon>
                                            </td>
                                            <td>
                                                <div
                                                    class="d-flex align-items-center icon-container">
                                                    <span
                                                        class="document-visualizer document-visualizer-{{ sign.id }}"
                                                        style="cursor: pointer;">
                                                        {{ getSignedText(sign)
                                                        }}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>

            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="comparingVersions">
    <!-- Lado esquerdo - Versão Principal -->
    <div class="row">
        <div class="col-6">
            <ng-container *ngIf="mainLoading">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="!mainLoading">
                <ng-container
                    *ngIf="approvalService.approvalData.mainVersion && approvalService.approvalData.mainRevision">
                    <div class="dash-details-card card-padding-top">
                        <app-empty-content [isVisible]="mainData.length === 0"
                            title="Nenhuma assinatura encontrada"
                            description="Não foi encontrada nenhuma assinatura nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <ng-container *ngIf="mainData.length > 0">
                            <ng-container *ngFor="let item of mainData">
                                <ng-container
                                    *ngIf="item.signs && item.signs.length > 0">
                                    <div class="table-scroll-container">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Vínculo</th>
                                                    <th>Data</th>
                                                    <th class="text-center">
                                                        Assinado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let sign of item.signs">
                                                    <td>
                                                        <div
                                                            class="d-flex align-items-center">
                                                            <div
                                                                class="dash-card-item-content">
                                                                <div
                                                                    class="dash-card-item-content-title">
                                                                    {{
                                                                    getName(sign)
                                                                    }}
                                                                </div>
                                                                <div
                                                                    class="dash-card-item-content-subtitle">
                                                                    {{
                                                                    sign.type_display
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{{ sign.type_display }}
                                                    </td>
                                                    <td>{{
                                                        formatDate(sign.updated_at)
                                                        }}</td>
                                                    <td class="text-center">
                                                        <svg-icon
                                                            [src]="getSignedIcon(sign)"
                                                            class="status-icon"></svg-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>

                    <app-spacer [bottom]="24"></app-spacer>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.mainVersion || !approvalService.approvalData.mainRevision">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container *ngIf="comparingDataLoading">
                <div class="dash-details-card card-padding-top">
                    <div class="table-scroll-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '150px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '100px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '120px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                    <th class="text-center">
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '20px', height: '20px', borderRadius: '50%' }">
                                        </ngx-skeleton-loader>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of [1,2,3]">
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="ms-2">
                                                <ngx-skeleton-loader
                                                    [theme]="{ width: '120px', height: '16px', marginBottom: '8px' }">
                                                </ngx-skeleton-loader>
                                                <ngx-skeleton-loader
                                                    [theme]="{ width: '80px', height: '14px' }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '100px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '120px', height: '16px' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td class="text-center">
                                        <ngx-skeleton-loader
                                            [theme]="{ width: '20px', height: '20px', borderRadius: '50%' }">
                                        </ngx-skeleton-loader>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!comparingDataLoading">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion && approvalService.approvalData.comparingRevision">
                    <div class="dash-details-card card-padding-top">
                        <app-empty-content
                            [isVisible]="comparingData.length === 0"
                            title="Nenhuma assinatura encontrada"
                            description="Não foi encontrada nenhuma assinatura nesse cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>

                        <ng-container *ngIf="comparingData.length > 0">
                            <ng-container *ngFor="let item of comparingData">
                                <ng-container
                                    *ngIf="item.signs && item.signs.length > 0">
                                    <div class="table-scroll-container">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Vínculo</th>
                                                    <th>Data</th>
                                                    <th class="text-center">
                                                        Assinado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let sign of item.signs"
                                                    [class]="item.compareClass"
                                                    [style.text-decoration]="item.compareClass === 'row-compare-removed' ? 'line-through' : 'none'">
                                                    <td>
                                                        <div
                                                            class="d-flex align-items-center">
                                                            <div class="me-3">
                                                                <svg-icon
                                                                    src="assets/images/icon-check-filled.svg"
                                                                    *ngIf="item.compareClass === 'row-compare-added'"
                                                                    class="text-success"></svg-icon>
                                                                <svg-icon
                                                                    src="assets/images/icon-times-circle.svg"
                                                                    *ngIf="item.compareClass === 'row-compare-removed'"
                                                                    class="text-danger"></svg-icon>
                                                            </div>
                                                            <div
                                                                class="dash-card-item-content">
                                                                <div
                                                                    class="dash-card-item-content-title">
                                                                    <svg-icon
                                                                        src="assets/images/icon-warning.svg"
                                                                        *ngIf="item.compareClass === 'row-compare-modified' && isFieldChanged(sign, 'name')"
                                                                        class="text-warning me-3"></svg-icon>
                                                                    {{
                                                                    getName(sign)
                                                                    }}
                                                                </div>
                                                                <div
                                                                    class="dash-card-item-content-subtitle">
                                                                    {{
                                                                    sign.type_display
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <svg-icon
                                                            src="assets/images/icon-warning.svg"
                                                            *ngIf="item.compareClass === 'row-compare-modified' && isFieldChanged(sign, 'type')"
                                                            class="text-warning me-3"></svg-icon>
                                                        {{ sign.type_display }}
                                                    </td>
                                                    <td>
                                                        <svg-icon
                                                            src="assets/images/icon-warning.svg"
                                                            *ngIf="item.compareClass === 'row-compare-modified' && isFieldChanged(sign, 'date')"
                                                            class="text-warning me-3"></svg-icon>
                                                        {{
                                                        formatDate(sign.updated_at)
                                                        }}
                                                    </td>
                                                    <td class="text-center">
                                                        <svg-icon
                                                            src="assets/images/icon-warning.svg"
                                                            *ngIf="item.compareClass === 'row-compare-modified' && (isFieldChanged(sign, 'signed') || isFieldChanged(sign, 'approved'))"
                                                            class="text-warning me-3"></svg-icon>
                                                        <svg-icon
                                                            [src]="getSignedIcon(sign)"
                                                            [class]="getSignedIcon(sign)"
                                                            class="status-icon"></svg-icon>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>

                    <app-spacer [bottom]="24"></app-spacer>
                </ng-container>
                <ng-container
                    *ngIf="!approvalService.approvalData.comparingVersion || !approvalService.approvalData.comparingRevision">
                    <app-select-version-comparison></app-select-version-comparison>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>

<app-modal #modalRoot class="modal-demo">
    <ng-container class="app-modal-header">
        <ng-container *ngIf="file">
            <svg-icon src="assets/images/icon_drag_indicator.svg"></svg-icon>
            <div>{{file.type.name}}</div>
            <div></div>
        </ng-container>
    </ng-container>
    <ng-container class="app-modal-body">
        <ng-container *ngIf="file">
            <img [src]="url" *ngIf="!isPDF && !isXLS" style="width:100%">
            <iframe [src]="url" *ngIf="isPDF || isXLS" frameborder="0"
                height="100%" width="100%">
            </iframe>
        </ng-container>
    </ng-container>
</app-modal>